/**
 * Core API utilities and shared functions
 * Extracted from services/api.ts
 */

import { useAppStore } from '../../store';
import { secureRandomIntInclusive } from '../../utils/ids';

/**
 * Simulates network delay for API calls.
 * @param min - Minimum delay in milliseconds (default: 300)
 * @param max - Maximum delay in milliseconds (default: 800)
 * @returns Promise that resolves after random delay
 */
export const delay = (min = 300, max = 800) => {
  if (import.meta.env.MODE === 'test') return Promise.resolve();
  const ms = secureRandomIntInclusive(min, max);
  return new Promise(resolve => setTimeout(resolve, ms));
};

/**
 * Gets current user context from store.
 * Context is synced to the router/db layer when requests are made via transport (in-process tests).
 * HTTP identity comes from the Clerk Bearer token only.
 */
export const getContext = () => {
  const { currentUserId, userRole, isSelfManagingOwner } = useAppStore.getState();
  return { currentUserId, userRole, isSelfManagingOwner };
};
